import React, { useRef, useEffect, useState } from "react";
import Webcam from "react-webcam";

//*MUI
import { Box, Modal } from "@mui/material";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import { makeStyles } from "@mui/styles";
import Close from "../Components/Icons/Close";
import Button from "./Button";
import cameraCaptureIcon from "../Assets/Images/Common/CameraCaptureIcon.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

const useStyles = makeStyles((theme) => ({
  Container: {
    backgroundColor: "#F9FAFB",
    // width: "100%",
    padding: "2rem",
    borderRadius: "8px",
  },
  TextTitle: {
    color: "#155EEF",
    fontSize: "1.3rem",
    lineHeight: "1.9rem",
    fontFamily: "Inter-Regular",
    textDecoration: "underline",
    cursor: "pointer",
    textAlign:"center",
  },
  SubContainer: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    flexDirection: "column",
    border: "1px dashed #344054",
    borderRadius: "8px",
  },
  CameraWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "2rem",
  },
  headerDiv: {
    backgroundColor: "#ffffff",
    borderBottom: " 2px solid #eaecf0",
    padding: "1.5rem 3.2rem",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "2rem",
  },
  mainContainer: {
    background: "#ffffff",
    padding: " 2rem",
    borderBottom: "1px solid #eaecf0",
  },
  mainContainerForCameraModal: {
    background: " #F2F4F7",
    display: " flex",
    flexDirection: " column",
    justifyContent: "center",
    alignItems: " center",
  },
  FooterDiv: {
    backgroundColor: "#ffffff",
    borderTop: "2px solid #eaecf0",
    padding: "1.5rem 3.2rem",

    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
  },
  cameraContainer: {
    width: "40rem",
    height: "30rem",
    padding: "3rem",
    // background:
    //   "linear-gradient(180deg, rgba(0, 0, 0, 0) 72.4%, rgba(0, 0, 0, 0.025) 100%), linear-gradient(180deg, rgba(0, 0, 0, 0.025) 0%, rgba(0, 0, 0, 0) 34.9%)",
    borderRadius: "12px",
    display: " flex",
    flexDirection: " column",
    justifyContent: "center",
    alignItems: "center",
  },
  containerCamera: {
    padding: "8rem",
  },
}));

function CameraCapture({
  InitialData,
  UploadedData,
  SaveData,
  WebCamOpen,
  HandleCaptureClose,
  CapturePhoto,
  Flag = true,
  siteVist = false,
  uploadPhotoAccess = false,
}) {
  const classes = useStyles();
  const [uploadedImage, setUploadedImage] = useState(null);
  // **For check,image uploaded
  const [isUpload,setIsUpload]=useState(false);
  useEffect(() => {
    console.log(InitialData, uploadedImage);
    setUploadedImage(InitialData);
  }, [InitialData]);
  const reUpload =()=>{
    console.log(document.getElementById("imgupload"))
    document.getElementById("imgupload").click();
  }
  return (
    <>
      {Flag === true && (
        <>
          <Box className={classes.Container}>
            <Box className={classes.SubContainer}>

              {uploadedImage === null ? (
                <Box className={classes.containerCamera}>
                  <Box className={classes.CameraWrapper}>
                    <CameraAltOutlinedIcon
                      style={{
                        width: "2.5rem",
                        height: "2.5rem",
                        color: "#475467",
                      }}
                    />
                  </Box>
                  <Box className={classes.TextTitle} onClick={CapturePhoto}>
                    Capture Photo
                  </Box>
               
                  {siteVist && uploadPhotoAccess && (
                    <div>
                      <Box
                        className={classes.TextTitle}
                        style={{
                          color: "#344054",
                          textAlign: "center",
                          marginTop: "0.5rem",
                          marginBottom: "0.5rem",
                        }}
                      >
                        Or
                      </Box>
                      <Box
                        className={classes.TextTitle}
                        onClick={() => {
                          document.getElementById("imgupload").click();
                        }}
                      >
                        Upload Photo
                      </Box>
                    </div>
                  )}
                </Box>
              ) : (
                <Box style={{
                  textAlign:'center'
                }}>
                  <img
                    style={{
                      width:'16rem',
                      height:'16rem',
                      objectFit:'contain'
                    }}
                    src={uploadedImage}
                    alt=""
                    // width={'15rem'}
                    // height={InitialData ? 'auto' : '15rem'}
                  />
                  <Box ml={"auto"}>
                    <Button
                      style={{
                        color: "#155EEF",
                        backgroundColor: "#F9FAFB",
                        border: "0",
                        Line: "underline",
                        boxShadow: "none",
                      }}
                      btnName={isUpload?"Re-Upload":"Re-Capture"}
                      clicked={isUpload?reUpload:CapturePhoto}
                    />
                          <Button
                      style={{
                        color: "#155EEF",
                        backgroundColor: "#F9FAFB",
                        border: "0",
                        Line: "underline",
                        boxShadow: "none",
                      }}
                      btnName={uploadPhotoAccess?isUpload?"Capture":"Upload":''}
                      clicked={uploadPhotoAccess?isUpload?CapturePhoto:reUpload:''}
                    />
                 
                  </Box>
                </Box>
              )}
                <input
                          hidden
                          type="file"
                          accept="image/*"
                          id="imgupload"
                          name=""
                          onChange={(e) => {
                            var file = e.target.files[0];
                            let reader = new FileReader();
                            reader.onload = (e) => {
                              let image = e.target.result;
                              // InitialData = { image };
                              console.log(image);
                              setUploadedImage(image);
                              UploadedData(image)
                              setIsUpload(true);
                            };
                            reader.readAsDataURL(file);
                            // setImageBase64(e.target.files[0]);
                            console.log(e.target.files);
                          }}
                        />
            </Box>
          </Box>
        </>
      )}

      <WebCamModal
        open={WebCamOpen}
        handleClose={HandleCaptureClose}
        ImageData={uploadedImage}
        OnChangeData={UploadedData}
        ImageClicked={() => SaveData()}
      />
    </>
  );
}

function WebCamModal({
  open,
  handleClose,
  ImageData,
  OnChangeData,
  ImageClicked,
}) {
  const classes = useStyles();
  const webcamRef = useRef(null);
  const [typeOfFaceMode, setTypeOfFaceMode] = useState("user");


  function capture() {
    
    let _image = webcamRef.current.getScreenshot();
    OnChangeData(_image);
  }

  function modalClose() {
    OnChangeData(null);
    handleClose();
  }

  return (
    <Modal
      open={open}
      onClose={modalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box sx={style}>
        <Box className={classes.headerDiv}>
          <Box className={classes.flexRow}>
            <Box component={"h2"}>Capture Photo</Box>
            <Box ml={"auto"} mt={2} onClick={modalClose}>
              <Close width={"1.5rem"} height={"1.5rem"} />
            </Box>
          </Box>
        </Box>

        <Box
          className={`${classes.mainContainer} ${classes.mainContainerForCameraModal}`}
        >
          <Box className={classes.cameraContainer}>
            {ImageData&&(
            <img
              style={{
                width:'38rem',
                height:'29rem',
                objectFit:'contain'
              }}
              src={ImageData}
              alt=""
              width={ImageData ? "auto" : "0px"}
              height={ImageData ? "auto" : "0px"}
            />
            )}

            <Webcam
              audio={false}
              height={ImageData ? 0 : 300}
              width={ImageData ? 0 : 300}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
                videoConstraints={{
                  facingMode: typeOfFaceMode,
                }}
              
            />
          </Box>
        </Box>

        <Box className={classes.FooterDiv}>
          <Box className={classes.flexRow}>
            <Box ml={"auto"}>
              <Button
                style={{
                  color: "#155EEF",
                  backgroundColor: "#ffffff",
                  border: "1px solid #0070E0",
                }}
                btnName={ImageData ? "Re-Capture" : "Capture"}
                clicked={() => {
                  if (ImageData) {
                    OnChangeData(null);
                  } else {
                    capture();
                  }
                }}
              />
            </Box>
            {!ImageData&&(
            <Box>
            <Button
              style={{ color: "#344054", backgroundColor: "#ffffff" }}
              btnName={"Flip Camera"}
              clicked={(e) => {
                e.preventDefault();
                console.log({typeOfFaceMode});
                if (typeOfFaceMode === "environment") {
                  setTypeOfFaceMode("user");
                } else {
                  setTypeOfFaceMode("environment");
                }
              } } />
              </Box>

            )}
            {ImageData&&(
              <Box>
              <Button
                style={{ color: "#ffffff", backgroundColor: "#155EEF" }}
                btnName={"Done"}
                clicked={ImageClicked}
                disable={ImageData ? false : true}
              />
            </Box>
            )}
            
            </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default CameraCapture;
